import React, { useEffect } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import '../CSS/OurApproach.css';
import ScrollReset from '../Tools/ScrollReseter';
import HorizontalLine from '../PageElements/HorizontalLine';

export default function OurApproach() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header imageURL={'Images/Approach.png'} title={'Our Approach'} titleSize={windowWidth > 750 ? 48 : 28} stretchHeight='null' yOffset={-50} windowWidth={windowWidth}/>
        <Content windowWidth={windowWidth}/>
        <Footer imageURL={'Images/Approach.png'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function Content({windowWidth}) {
  return (
    <>
      <div className='content' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '50px' }}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
          <Section windowWidth={windowWidth} headerText={'Heavy Math Focus'} imgageURl={'Images/MathFocus.jpg'}>
            <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
              Sókn Engineering is an engineering firm that has created a new type of determinant mathematics called Modular Calculus. It is based on
              vector and decryption mathematics as well as polymorphic differential rate sequencing. We look at the market from the inside out, not
              outside in – instead of using probability gated statistical models that measure the worlds effect on the commodity or financial
              instrument, Sókn Engineering uses synchronized encryption based mathematical models to evaluate the commodity or financial instrument
              from within the market
            </p>
          </Section>
        </div>

        <HorizontalLine />

        <Section windowWidth={windowWidth} headerText={'Sókn Engineering Math Models'} imgageURl={'Images/MathModels.png'} reversedDirection={true}>
          <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
            Sókn Engineering’s proprietary Modular Calculus represents a groundbreaking departure from traditional theorem-based quantitative models.
            Instead of relying on probability-gated statistical frameworks, our models utilize deterministic chaos mathematics, integrating
            vector-based decryption physics and polymorphic differential rate sequencing to analyze financial markets from within. <br /> <br /> Our
            system processes 550 million interconnected algorithms, executing 32 trillion fully automated thought processes to track, predict, and
            react to market fluctuations in real time. Unlike conventional trading models, which degrade as markets shift beyond predefined
            parameters, Sókn’s models dynamically recompose mathematical structures within a spherical vector space, allowing continuous recalibration
            without loss of accuracy. By deciphering algorithmic output signatures from primary liquidity providers, our technology identifies price
            inversion points and market pressures at a quantum level. This ensures that price predictions are accurate down to the half-penny, while
            simultaneously mitigating exposure and eliminating unnecessary risk. With a self-learning architecture powered by AI and machine learning,
            Sókn’s models evolve autonomously, adapting to new market conditions without requiring human intervention.
          </p>
        </Section>

        <HorizontalLine />

        <Section windowWidth={windowWidth} headerText={'Sókn Engineering Artificial Intelligence'} imgageURl={'Images/AI.png'}>
          <p style={{ lineHeight: '150%', fontFamily: 'Lato' }}>
            Sókn Engineering’s AI is built for autonomous market intelligence, integrating reinforcement learning and self-scripting algorithms to
            continuously adapt and optimize trading strategies. Unlike static models, our AI refines its predictive accuracy through real-time
            feedback loops, learning from market fluctuations and adjusting its parameters dynamically. Reinforcement learning enables the system to
            maximize profitable outcomes by iterating on past performance, while self-scripting allows it to generate and modify its own trading logic
            without human intervention. This adaptive intelligence ensures that Sókn’s AI remains resilient to market shifts, consistently delivering
            precision-driven financial insights and execution.
          </p>
        </Section>

        <HorizontalLine />

        <div
          id='soknmathmodels'
          style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
          <h1>Our current Models</h1>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'baseline',
              gap: '10px',
              marginTop: '30px',
              marginBottom: windowWidth > 740 ? '40px' : '0px',
              flexWrap: 'wrap',
              height: '100%',
            }}>
            <div className='modelCard'>
              <h1>SID3</h1>
              <ul>
                <li>
                  <b>Reactive Model</b>
                </li>
                <li>
                  Sókn Engineering has a trade model called the HyperFund Engine (HFE) designed to trade every change in price direction (vector
                  inversion) within a given time period.
                </li>
                <li>
                  SID3 is one of the algorithm sets which function like a trader — this means intuition-based modeling (follows specific algorithmic
                  parameters) that differentiate between predictable output of those parameters.
                </li>
                <li>Measures small price changes in the quantum spaces left in the wake of the larger price movements.</li>
                <li>Lives in the noise of the market.</li>
              </ul>
            </div>

            <div className='modelCard'>
              <h1>WYRD</h1>
              <ul>
                <li>
                  <b>Thinking Model</b>
                </li>
                <li>Creates the ability to think through synchronized confluences within the output of robust vector-based algorithms.</li>
                <li>
                  Wyrd's logic switches and logic gates are controlled by Sókn Engineering's HNN, algorithmic controlled TPS (Tensor Processing
                  System) methods.
                </li>
                <li>Result — measures their intentions from point A to B, the large vector spaces of commodities.</li>
                <li>Predicts the next 48 hours.</li>
              </ul>
            </div>

            <div className='modelCard'>
              <h1>SEIDR</h1>
              <ul>
                <li>
                  <b>Reactive Model</b>
                </li>
                <li>
                  By deciphering the algorithmic output signature (resultant) of the largest commodity market liquidators, it allows Seidr to "reason"
                  through movement.
                </li>
                <li>Based only on the primary algorithm market drivers and tracks them throughout the year.</li>
                <li>Measures the vector from point A to its terminus across days to the half penny of the price point.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Section({windowWidth, headerText, imgageURl, reversedDirection, children}){
  return (
    <>
      {windowWidth > 880 ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '80px', marginTop: '20px', marginBottom: '20px' }}>
            {reversedDirection ? (
              <>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    alt=''
                    src={imgageURl}
                    height={300}
                    width={420}
                    style={{
                      borderRadius: '10px',
                      border: '1px solid #bc9c4e',
                      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                      minWidth: '100px',
                      maxWidth: '420px',
                      height: 'auto',
                      width: '100%',
                    }}
                  />

                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>

                <div
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '650px', gap: '10px' }}>
                  <h1 className='bodyHeader'>{headerText}</h1>

                  {children}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '650px', gap: '10px' }}>
                  <h1 className='bodyHeader'>{headerText}</h1>

                  {children}
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px' }}>
                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    alt=''
                    src={imgageURl}
                    height={300}
                    width={420}
                    style={{
                      borderRadius: '10px',
                      border: '1px solid #bc9c4e',
                      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                      minWidth: '100px',
                      maxWidth: '420px',
                      height: 'auto',
                      width: '100%',
                    }}
                  />

                  <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                    <defs>
                      <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#BC9C4E' />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: '20px',
              marginTop: '20px',
              marginBottom: '20px',
              width: '100%',
            }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', width: '100%' }}>
              <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                <defs>
                  <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                  </linearGradient>
                </defs>
              </svg>

              <img
                alt=''
                src={imgageURl}
                height={300}
                width={420}
                style={{
                  borderRadius: '10px',
                  border: '1px solid #bc9c4e',
                  boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
                  minWidth: '200px',
                  maxWidth: '420px',
                  height: 'auto',
                  width: '100%',
                }}
              />

              <svg width='2' height='121' viewBox='0 0 2 121' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M1 0.652344V120.189' stroke='url(#paint0_linear_208_222)' />
                <defs>
                  <linearGradient id='paint0_linear_208_222' x1='1' y1='0.727335' x2='26.5072' y2='6.20883' gradientUnits='userSpaceOnUse'>
                    <stop stopColor='#BC9C4E' />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%', gap: '10px' }}>
              <h1 className='bodyHeader'>{headerText}</h1>

              {children}
            </div>
          </div>
        </>
      )}
    </>
  );
}